import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomHeading from "../../../../components/customText/CustomHeading";
import NoDataAvailableScreen from "../../../../components/screens/NoDataAvailableScreen";
import EmptyCart from "./EmptyCart";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import BlueOutlinedSmallButton from "../../../../components/customButtons/BlueOutLinedSmallButton";
import BlueLightOutlinedButton from "../../../../components/customButtons/BlueLightOutlineButton";
import { useDispatch, useSelector } from "react-redux";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import PurchaseTestCard from "../components/TestCard";
import BlueMediumButton from "../../../../components/customButtons/BlueMediumButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import BlueLightOutLinedMediumButton from "../../../../components/customButtons/BlueLightOutLinedMediumButton";
import { CLEAR_TEST_CART, REMOVE_TEST_FROM_CART } from "../../../../../actions";
import {
  addOneTestItemToCart,
  removeAllTestFromCart,
} from "../PurchaseTestApis";
import DeleteConfirmationPopup from "../../../../components/customPopup/DeleteConfirmationPopup";
import SussceeffulyMessageScreen from "../../../../components/customPopup/SussceeffulyMessageScreen";
import DisableBlueSmallButton from "../../../../components/customButtons/DisableSmallBlueButton";
import BlueDisableButton from "../../../../components/customButtons/BlueDisableButton";
import { setDefaultTestDataList } from "../../../../../redux/features/testTypecheckout/ProceedWithTestDataReducer";
import { useSnackbar } from "../../../../components/snackbars/SnackbarContext";

export default function MyExamCart() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const { items: purchaseTestItem, loading } = useSelector(
    (state) => state.purchasetestcart
  );
  const [purchaseTestData, setPurchaseTestData] = useState(purchaseTestItem);
  const [count, setCount] = useState({});
  const [testAmount, setAmount] = useState({});

  const redirectionLink = "/test-prep/performance/purchase-test";
  const handleNavigateToBackPage=()=>{
    navigate(-1)
  }
 
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);

  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [selectedTests, setSelectedTests] = useState({});
  const [selectedTestData, setSelectedTestData] = useState([]);
  const { showSnackbar } = useSnackbar();


  // feth data

  useEffect(() => {
    setPurchaseTestData(purchaseTestItem);
  }, [purchaseTestItem]);

  // Remove 1 from cart
  const handleTestRemoveFromCart = async (data) => {
    try {
      const response = await addOneTestItemToCart({
       // service_id: 1,
        real_test_product_id: data?.id,
        is_adding: false,
        user_id: parseInt(userId),
      });

      if (response.status === 200) {
        dispatch({
          type: REMOVE_TEST_FROM_CART,
          payload: data, //  full object from API
        });

        showSnackbar(response.message, "success");
        // update local UI
        setPurchaseTestData((prev) =>
          prev.filter((item) => item.id !== data?.id)
        );
      } else {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch {
      showSnackbar("Something went wrong", "error");
    }
  };

  // delete all popop
  const handleOpendeletePopup = (data) => {
    setOpenDeleteConfirmation(true);
  };

  const handleClosedeletePopup = () => {
    setOpenDeleteConfirmation(false);
  };

  // remove all item from wishlist
  const handleRemoveAllItem = async () => {
    try {
      const response = await removeAllTestFromCart(userId);

      if (response.status === 200) {
        // showSnackbar(response.message, "success");
        handleClosedeletePopup();
        handleOpenSuccessPopup();

        //  update redux
        dispatch({ type: CLEAR_TEST_CART });

        // update local UI
        setPurchaseTestData([]);
      } else {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch (error) {
      showSnackbar("Something went wrong", "error");
    }
  };

  // open success popup
  const handleOpenSuccessPopup = () => {
    setOpenSuccesPopup(true);
  };

  // close success popup
  const handleCloseSuccessPopup = () => {
    setOpenSuccesPopup(false);
  };

  // Initialize selectedTests when purchaseTestData changes
  useEffect(() => {
    const initialSelected = {};
    purchaseTestData?.forEach((item) => {
      initialSelected[item.id] = false;
    });
    setSelectedTests(initialSelected);
    setSelectedTestData([]); // reset selected data
  }, [purchaseTestData]);

  // Check if all items are selected
  const allSelected = purchaseTestData?.every((item) => selectedTests[item.id]);

  // Toggle select all / deselect all

  const handleToggleSelectAll = () => {
  const newSelected = {};
  const newSelectedData = [];

  purchaseTestData?.forEach((item, index) => {
    const shouldSelect = !allSelected;
    newSelected[item.id] = shouldSelect;

    if (shouldSelect) {
      newSelectedData.push({
        ...item,
        quantity: count[index],
        product_amount: testAmount[index],
        base_price: item.product_amount, // store base price
      });
    }
  });

  setSelectedTests(newSelected);
  setSelectedTestData(newSelectedData);
};


  const handleToggleCheckbox = (item) => {
  const itemIndex = purchaseTestData.findIndex((t) => t.id === item.id);

  setSelectedTests((prev) => {
    const newState = { ...prev, [item.id]: !prev[item.id] };

    // Create updated selected data list
    const selected = Object.keys(newState)
      .filter((id) => newState[id])
      .map((id) => {
        const test = purchaseTestData.find((t) => t.id === parseInt(id));
        const idx = purchaseTestData.findIndex((t) => t.id === parseInt(id));

        return {
          ...test,
          quantity: count[idx],          // store updated quantity
          product_amount: testAmount[idx],   // store updated amount
           base_price: test.product_amount, // store base price
        };
      });

    setSelectedTestData(selected);

    return newState;
  });
};



   // default amount for each card on 1st render
  useEffect(() => {
    if (purchaseTestData?.length > 0) {
      const initialAmount = {};
      purchaseTestData.forEach((item, index) => {
        initialAmount[index] = item.product_amount * item?.quantity; // default count is 1
      });
      setAmount(initialAmount);
    }
  }, [purchaseTestData]);

  // default count for each card on 1st render

 useEffect(() => {
  if (purchaseTestData?.length > 0) {
    const initialCounts = {};
    purchaseTestData.forEach((item, index) => {
      initialCounts[index] = item?.quantity ?? 1; // fallback to 1
    });
    setCount(initialCounts);
  }
}, [purchaseTestData]);



const handleIncrement = (index) => {
  setCount((prev) => {
    const newCount = prev[index] + 1;

    const newAmount = purchaseTestData[index].product_amount * newCount;

    // update amount
    setAmount((prevAmt) => ({
      ...prevAmt,
      [index]: newAmount,
    }));

    // update selected data also
    setSelectedTestData((prevSel) => {
      // check if this item is already selected
      const testId = purchaseTestData[index].id;
      if (!selectedTests[testId]) return prevSel; // not selected, skip

      return prevSel.map((item) =>
        item.id === testId
          ? { ...item, quantity: newCount, product_amount: newAmount,base_price: item.product_amount }
          : item
      );
    });

    return { ...prev, [index]: newCount };
  });
};


const handleDecrement = (index) => {
  setCount((prev) => {
    const newCount = prev[index] > 1 ? prev[index] - 1 : 1;

    const newAmount = purchaseTestData[index].product_amount * newCount;

    // update amount
    setAmount((prevAmt) => ({
      ...prevAmt,
      [index]: newAmount,
    }));

    // update selected data also
    setSelectedTestData((prevSel) => {
      const testId = purchaseTestData[index].id;
      if (!selectedTests[testId]) return prevSel;

      return prevSel.map((item) =>
        item.id === testId
          ? { ...item, quantity: newCount, product_amount: newAmount,base_price: item.product_amount }
          : item
      );
    });

    return { ...prev, [index]: newCount };
  });
};


 

 const totalQuantityAmout = selectedTestData.reduce((sum, val) => sum + val?.product_amount, 0);

const handleProceedToPay =()=>{
  dispatch(setDefaultTestDataList(selectedTestData));
  navigate("/test-prep/performance/purchase-test/checkout")
}



  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        {/* Scrollable area */}
        <Box sx={{ flex: 1, overflowY: "auto", px: 2, py: 1 }}>
          <Grid container spacing={2} position="relative">
            <Grid item xs={12} sm={6}>
              <CustomHeading lable="My Exam Cart" onClick={handleNavigateToBackPage}/>
            </Grid>

            {purchaseTestItem?.length > 0 && (
              <Grid
                item
                xs={12}
                sm={6}
                textAlign="end"
                container
                gap={2}
                justifyContent="flex-end"
              >
                <BlueLightOutlinedButton
                  buttonTitle={allSelected ? "Deselect All" : "Select All"}
                  onClick={handleToggleSelectAll}
                />
                <BlueLightOutlinedButton
                  buttonTitle="Remove All"
                  onClick={() => handleOpendeletePopup()}
                />
              </Grid>
            )}

            {loading ? (
              <Grid item xs={12}>
                <Loader text="Loading..." />
              </Grid>
            ) : !loading && purchaseTestData?.length > 0 ? (
              <>
                <Grid item xs={12}>
                  <CustomCardWithBorder boxShadow={true} height="100%">
                    <Grid container spacing={3}>
                      {purchaseTestData?.map((data, index) => (
                        <Grid item xs={12} sm={6} md={4}>
                          <PurchaseTestCard height="100%">
                            <Grid container spacing={1.5}>
                              <Grid
                                item
                                xs={11}
                                container
                                alignItems="center"
                                gap={1}
                              >
                                <Box
                                  sx={{
                                    border: "1px solid rgba(238, 238, 238, 1)",
                                    borderRadius: "8px",
                                    padding: "6px",
                                  }}
                                >
                                  <img
                                    src={data?.image_path?.image_src}
                                    style={{ width: "32px" }}
                                  />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#56595D",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {data?.sub_test_type_id
                                    ? data?.sub_test_type_id?.name
                                    : data?.test_type_id?.name}{" "}
                                  - {data?.product_name}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xs={1}
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                              >
                                <Checkbox
                                  sx={{ p: 0 }}
                                  checked={!!selectedTests[data.id]}
                                  onChange={() => handleToggleCheckbox(data)}
                                  icon={
                                    <Box
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        border: "1px solid #572575",
                                        borderRadius: "2px",
                                      }}
                                    />
                                  }
                                  checkedIcon={
                                    <Box
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        border: "1px solid #572575",
                                        borderRadius: "2px",
                                        backgroundColor: "#572575",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#fff",
                                        fontSize: 16,
                                      }}
                                    >
                                      <Icon icon="qlementine-icons:check-tick-12" />
                                    </Box>
                                  }
                                />
                              </Grid>

                              <Grid item xs={12}>
                                <Divider sx={{ borderColor: "#EEEEEE" }} />
                              </Grid>

                              <Grid item xs={12}>
                                <Typography
                                  sx={{
                                    fontSize: "18px",
                                    fontWeight: 800,
                                    color: "#572575",
                                  }}
                                >
                                  {data?.currency}
                                  {""} {testAmount[index]}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xs={8}
                                container
                                alignItems="center"
                                justifyContent="flex-start"
                                gap={0.5}
                              >
                                <img
                                  src="/PurchaseTest/Vector (7).png"
                                  style={{ width: "16px", marginLeft: "-4px" }}
                                />

                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    color: "#333333",
                                  }}
                                >
                                  Question Quantity :{" "}
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#333333",
                                    }}
                                  >
                                    {data?.question_quantity}
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item xs={4} textAlign="end">
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",

                                    justifyContent: "space-between",
                                    p: "4px",
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDecrement(index)}
                                    sx={{
                                      border: "0.5px solid #E9D0F8",
                                      color: "#572575",
                                      width: "22px",
                                      height: "22px",
                                      borderRadius: "4px",
                                      background: "#ffffff",
                                      opacity: count[index] === 1 ? 0.3 : 1,
                                    }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </IconButton>

                                  <Typography
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      width: "30px",
                                      textAlign: "center",
                                      fontFamily: "Inter",
                                      color: "#000000",
                                    }}
                                  >
                                    {count[index]?.toString().padStart(2, "0")}
                                  </Typography>

                                  <IconButton
                                    size="small"
                                    onClick={() => handleIncrement(index)}
                                    sx={{
                                      border: "0.5px solid #E9D0F8",
                                      color: "#572575",
                                      width: "22px",
                                      height: "22px",
                                      borderRadius: "4px",
                                      background: "#ffffff",
                                    }}
                                  >
                                    <AddIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Grid>

                              <Grid item xs={12}>
                                <BlueLightOutLinedMediumButton
                                  buttonTitle="Remove"
                                  minWidth="100%"
                                  onClick={() => handleTestRemoveFromCart(data)}
                                  textColor="#000000"
                                  fontWeight={600}
                                />
                              </Grid>
                            </Grid>
                          </PurchaseTestCard>
                        </Grid>
                      ))}
                    </Grid>
                  </CustomCardWithBorder>
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <EmptyCart
                  topImage={
                    <img src="/PurchaseTest/Group 1171283373 (2).png" />
                  }
                  topimageWidth="94px"
                  text="Your cart is empty"
                  subText="You haven't added any test to your  cart yet. Explore our test and add your cart to compare them later."
                  buttonName="Purchase Test"
                  maxWidth="100%"
                  startIcon={<Icon icon="material-symbols:crown-rounded" />}
                  redirectionLink={redirectionLink}
                />
              </Grid>
            )}
          </Grid>
        </Box>

        {/* Sticky footer */}
        {purchaseTestData?.length>0 && ( 
        <Box
          sx={{
            position: "sticky",
            bottom: 1,
            bgcolor: "#fff",
            // boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Inter",
              color: "#333333",
            }}
          >
            Subtotal{" "}
            <span
              style={{ fontWeight: 500, fontSize: "16px", color: "#333333" }}
            >
             {selectedTestData?.length >0 && `(${selectedTestData?.length} items)` } 
            </span>
            :{" "}
            <span
              style={{ fontWeight: 700, fontSize: "16px", color: "#572575" }}
            >
             {selectedTestData?.length >0 ? `${selectedTestData[0]?.currency}  ${totalQuantityAmout} `: " No Test Selected"} 
            </span>
          </Typography>

          {selectedTestData?.length === 0 ? (
            <BlueDisableButton
              buttonTitle="Proceed To Pay"
              endIcon={<Icon icon="material-symbols-light:lock" />}
            />
          ) : (
            <BlueMediumButton
              buttonTitle="Proceed To Pay"
              endIcon={<Icon icon="material-symbols-light:lock" />}
              height="32px"
              onClick={handleProceedToPay}
            />
          )}
        </Box>
        )}
      </Box>

     

      {/* delete all confirmation dialoge */}

      <DeleteConfirmationPopup
        open={openDeleteConfirmation}
        text="Remove All Tests  ?"
        subtext={
          <>
            Are you sure you want to remove <strong>all tests</strong> from your
            cart?
          </>
        }
        buttonTitle="Yes, Remove It"
        handleClose={handleClosedeletePopup}
        handleSubmit={handleRemoveAllItem}
      />

      {/* success messgae screen */}
      <SussceeffulyMessageScreen
        text="All Tests Successfully Removed !"
        buttonTitle="Thanks, Got it"
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />
    </>
  );
}
